export default "/images/cat-logo-6.png?336c6bec4eb2c53fab0c17d5eaa70229";